<template>
    <div>
        <Header></Header>
        <div class="aboutusCon">
            <div class="cover"></div>
            <!-- <div class="content">
                <div class="about">
                    <div class="con"><big><big>ABOUT US</big></big></div>
                    <br>
                    <div class="con">Steppy is a creative media company founded in China in 2013. The core concept is to use creativity to change the lifestyle of young Chinese and enhance the lifestyle of young Chinese. Our business area covers all aspects of life. In the past seven years, we have established diversified partnerships with many quality brands around the world and have gained a good reputation in the Chinese market.</div>
                    <div class="con">Steppyplus is a trend culture production unit that continuously designs and develops high-quality trend lifestyle products based on the trend lifestyle knowledge learning advocated by steppy trend weekly and the current situation of the fans of steppy trend weekly.</div>
                    <div class="con">Steppyplus starts from the concept of "connectivity" to transform the seemingly ordinary items in life into a trend, arousing the uncertainty and possibility of all simple things, and endowing them with stronger trend attributes and styles.</div>
                </div>
                <div class="contact">
                    <div class="con"><big><big>CONTACT US</big></big></div>
                    <br>
                    <div class="con">E-MAIL：steppywechat@sina.com</div>
                    <div class="con">TEL：111111111111</div>
                </div>
            </div> -->
            <div class="content">
                <p v-html="item"></p>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '../../components/Header.vue'
export default{
  components:{
      Header
  },
  data() {
    return {
        item:''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const res = await this.$axios.get("steppyplus", {
      });
      this.item = res.data.about
    },
  },
}
</script>
<style scoped>
.aboutusCon{
    width: 100%;
    height: 100vh;
    padding-top: 8vh;
    display: inline-flex;
    background-color: #000;
}
.aboutusCon .cover{
    width: 45%;
    height: 91vh;
    min-height: inherit;
    background: transparent url('../../assets/aboutus.png') center no-repeat;
    background-size: 35%;
}
.aboutusCon .content{
    width: 55%;
    height: 91vh;
    font-size: 0.85vw;
    color: #fff;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 12% 20px;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/view/pc/AboutUs.vue